import { useContext } from "react";
import { ChangeStatusActionContext } from "./ChangeStatusActionContext";

function usePrepareChangeStatus() {
  const {
    setElementId,
    setStatusId,
    setShowModal,
    setElement,
    setBackendFormErrors,
  } = useContext(ChangeStatusActionContext);
  return (id: any, status: number) => {
    setElementId(id);
    setStatusId(status);
    // Reset state before opening modal
    if (typeof setBackendFormErrors === "function") setBackendFormErrors(null);
    if (typeof setElement === "function") setElement({});
    setShowModal(true);
  };
}

export default usePrepareChangeStatus;
